import * as _ from '../../models';
import { Funksjon, IdentitetAdresse, MiljoVariabel } from '../../models';
import RequestService from './requestService';
import IdentitetService from './extensions/identitetService';
import TekstmalService from './extensions/tekstmalService';
import BrukerService from './extensions/brukerService';
import saksTypeUniqueService from './extensions/saktypeUniqueService';
import journalkategoriDbViewService from './extensions/journalkategoriDbViewService';
import KurverServices from './extensions/kurverService';
import SoneService from './extensions/soneService';
import ArkivdelService from './extensions/arkivdelService';
import TilgangsgruppeService from './extensions/tilgangsgruppeService';
import AdmEnhetServices from './extensions/admEnhetService';
import RollemasterService from './extensions/rollemasterServices';
//import RollemasterLightService from './extensions/rollemasterLightService';
import RollemasterForKurvService from './extensions/rollemasterForKurvService';
import SystemparameterService from './extensions/systemparameterService';
import OrdningsVerdiService from './extensions/ordningsVerdiService';
import TilleggsdataService from './extensions/tilleggsdataService';
import ArsskifteServices from './extensions/arsskifteService';
import MeServices from './extensions/meService';
import GruppeService from './extensions/gruppeService';
import { PostnummerService } from './extensions/postnummerService';
import PresedensTagTypeService from './extensions/presedensTagTypeService';
import RequestTreeService from './requestTreeService';
import MiljoService from './extensions/miljoService';
import FlytstatusService from './extensions/flytstatusService';
import ReferansekodeService from './extensions/referansekodeService';
import ArkivService from './extensions/arkivService';
import ArkivPeriodeService from './extensions/arkivPeriodeService';
import OrdningsPrinsippService from './extensions/ordningsPrinsippService';
import AutorisasjonService from './extensions/autorisasjonService';
import { SubEntityRequestService } from './subEntityRequestService';
import DatabaseLokasjonerService from './extensions/databaseLokasjonerService';
import NodeTilgangService from './extensions/nodeTilgangService';
import { DataVerdi } from '../../models/dataVerdi';
import TilleggsdataKoblingService from './extensions/tilleggsdataKoblingService';
import RolleService from './extensions/rolleService';
import KommuneService from './extensions/kommuneService';
//import { KundeproduktOversiktService } from './extensions/kundeproduktOversiktService';   
import { LoggService } from './extensions/loggService';
import { Malsak } from '../../models/malsak';
import OrganiseringService from './extensions/organiseringService';
import TilgangskodeService from './extensions/tilgangskodeService';
import MalJournalpostService from './extensions/malJournalpostService';
import ArkivSakService from './extensions/arkivsakService';
import VarslingService from './extensions/varslingService';
import IndekseringLoggService from './extensions/indekseringLoggService';
import saksTypeUniqueLightService from './extensions/saktypeUniqueLightService';
import FunksjonService from './extensions/funksjonService';
import AdmEnhetLightServices from './extensions/admEnhetLightService';
import OrdningsVerdiLightService from './extensions/ordningsVerdiLightService';


export const fylkeService = new RequestService<_.Fylke, 'fylke'>('fylke');
export const gruppeService = new GruppeService();
export const relasjonLightService = new RequestService<_.RelasjonLight, 'RelasjonLight'>('RelasjonLight');
export const identitetService = new IdentitetService('identitet');
export const autorisasjonService = new AutorisasjonService();
export const identitetAdresseService = new SubEntityRequestService<IdentitetAdresse>('identitet', 'adresser');
export const identitetskategoriService = new RequestService<_.Identitetskategori, 'identitetskategori'>('identitetskategori');
export const kommuneService = new KommuneService('kommune');
export const landService = new RequestService<_.Land, 'land'>('land');
export const postnummerService = new PostnummerService('postnummer');
export const spraakService = new RequestService<_.Spraak, 'spraak'>('spraak');
export const tilgangsgruppeService = new TilgangsgruppeService();
//#region Arkiv
export const arkivdelService = new ArkivdelService('arkivdel');
export const arkivService = new ArkivService('arkiv');
export const arkivPeriodeService = new ArkivPeriodeService('arkivPeriode');
export const arkivstatusService = new RequestService<_.ArkivStatus, 'arkivstatus'>('arkivstatus');
export const avgraderingsKodeService = new RequestService<_.AvgraderingsKode, 'avgraderingsKode'>('avgraderingsKode');
export const avskjermingService = new RequestService<_.TilgangAvskjerming, 'avskjerming'>('avskjerming');
export const journalenhetService = new RequestService<_.Journalenhet, 'journalenheter'>('journalenheter');
export const journalenhetLightService = new RequestService<_.JournalenhetLight, 'journalenhetLight'>('journalenhetLight');
export const oppgaverService = new RequestService<_.Oppgaver, 'oppgaver'>('oppgaver');
export const oppgaverLightService = new RequestService<_.OppgaverLight, 'oppgaverLight'>('oppgaverLight');
// import GruppeService from './extensions/gruppeService';
export const kassasjonsKodeService = new RequestService<_.KassasjonsKode, 'kassasjons'>('kassasjons');
export const kassasjonOgBevaringsVedtakService = new RequestService<_.KassasjonOgBevaringsVedtak, 'kassasjonOgBevaringsVedtak'>('kassasjonOgBevaringsVedtak');
export const lovverkService = new RequestService<_.Lovverk, 'lovverk'>('lovverk');
export const ordningsPrinsippService = new OrdningsPrinsippService('ordningsPrinsipp');
export const ordningsPrinsippTypeService = new RequestService<_.OrdningsPrinsippType, 'ordningsPrinsippType'>('ordningsPrinsippType');
export const ordningsVerdiService = new OrdningsVerdiService('ordningsVerdi');
export const ordningsVerdiLightService = new OrdningsVerdiLightService('ordningsVerdiLight');
export const tilgangskodeService = new TilgangskodeService('tilgangskoder');
export const paragrafService = new RequestService<_.Paragraf, 'paragraf'>('paragraf');
export const eksternRessursService = new RequestService<_.EksternRessurs, 'eksternRessurs'>('eksternRessurs');
//#endregion Arkiv

export const ekspedisjonsKanalService = new RequestService<_.EkspedisjonsKanal, 'ekspedisjonsKanal'>('ekspedisjonsKanal');
export const eksternLinkService = new RequestService<_.EksternLink, 'eksternLink'>('eksternLink');
export const klokketypeService = new RequestService<_.Klokketype, 'klokketype'>('klokketype');
export const tagService = new RequestTreeService<_.Tag, 'tag'>('tag');
export const tagEgenskapService = new SubEntityRequestService<_.TagEgenskap>('tag', 'egenskap');
export const tagEgenskapTypeService = new RequestService<_.TagEgenskapType, 'TagEgenskapType'>('TagEgenskapType');


export const dokumentkategoriService = new RequestService<_.Dokumentkategori, 'dokumentkategori'>('dokumentkategori');
export const dokumentstatusService = new RequestService<_.Dokumentstatus, 'dokumentstatus'>('dokumentstatus');
export const dokumentTilknytningService = new RequestService<_.DokumentTilknytning, 'dokumentTilknytning'>('dokumentTilknytning');
export const formatVariantService = new RequestService<_.FormatVariant, 'formatVariant'>('formatVariant');
export const tekstmalService = new TekstmalService('tekstmal');

export const avskrivningsmateService = new RequestService<_.Avskrivningsmate, 'avskrivningsmate'>('avskrivningsmate');
export const behandlingstypeService = new RequestService<_.Behandlingstype, 'behandlingstype'>('behandlingstype');
export const dokumenttypeService = new RequestService<_.Dokumenttype, 'dokumenttype'>('dokumenttype');
export const forsendelsesmateService = new RequestService<_.Forsendelsesmate, 'forsendelsesmate'>('forsendelsesmate');
export const journalkategoriService = new RequestService<_.Journalkategori, 'journalkategori'>('journalkategori');
export const journalkategoriDbViewExstService = new journalkategoriDbViewService('journalkategori');
export const journalstatusService = new RequestService<_.Journalstatus, 'journalstatus'>('journalstatus');
export const journalstatuUniquesService = new RequestService<_.JournalstatusUnique, 'journalstatusUnique'>('journalstatusUnique');
export const malJournalpostService = new MalJournalpostService();
export const prioritetService = new RequestService<_.Prioritet, 'prioritet'>('prioritet');

export const fellesEpostboksService = new RequestService<_.FellesEpostboks, 'fellesEpostboks'>('fellesEpostboks');
export const tilgangsfunksjonService = new RequestService<_.Tilgangsfunksjon, 'tilgangsfunksjon'>('tilgangsfunksjon');
//#region Organisasjon
export const admEnhetService = new AdmEnhetServices('admEnhet');
export const admEnhetLightService = new AdmEnhetLightServices('admEnhetLight');
export const enhetstypeService = new RequestTreeService<_.Enhetstype, 'enhetstype'>('enhetstype');
export const profilarvService = new RequestService<_.ProfilArv, 'profilarv'>('profilarv');
export const organiseringService = new OrganiseringService('organisering');
//export const kundeproduktOversiktService = new KundeproduktOversiktService('KundeproduktOversikt');
export const loggService = new LoggService('logg');
export const brukerService = new BrukerService('bruker');
//#endregion Organisasjon

//#region Sak

export const sakstypeUniqueService = new saksTypeUniqueService('sakstypeUnique');

export const sakstypeUniqueLightService = new saksTypeUniqueLightService('sakstypeUniqueLight');
export const sakstypeService = new RequestService<_.Sakstype, 'saktype'>('saktype');

export const avgjorelsesKodeService = new RequestService<_.AvgjorelsesKode, 'avgjorelseskoder'>('avgjorelseskoder');

export const sakstatusService = new RequestService<_.Sakstatus, 'sakstatus'>('sakstatus');
export const malsakService = new RequestService<Malsak, 'malsak'>('malsak');

export const partsforholdService = new RequestService<_.Partsforhold, 'partsforhold'>('partsforhold');

export const arkivSakService = new ArkivSakService();

//#endregion Sak

//#region System
export const rollemasterService = new RollemasterService('rollemaster');
export const rolleService = new RolleService();

//cls export const rollemasterLightService = new RollemasterLightService('rollemasterLight');
export const rollemasterForKurvService = new RollemasterForKurvService('rollemasterForKurv');
export const soneService = new SoneService('sone');
export const organiseringsTypeServices = new RequestService<_.OrganiseringsType, 'organiseringsType'>('organiseringsType');
export const databaseService = new RequestService<_.Database, 'database'>('database');
export const databaseLokasjonService = new DatabaseLokasjonerService();

export const informasjonstypeService = new RequestService<_.Informasjonstype, 'informasjonstype'>('informasjonstype');
export const funksjonService = new FunksjonService('funksjon');
export const kurverServices = new KurverServices('kurv');

export const tekstkatalogService = new RequestService<_.Tekstkatalog, 'tekstkatalog'>('tekstkatalog');


export const presedensTagService = new RequestTreeService<_.PresedensTag, 'presedensTag'>('presedensTag');

export const lagringsformaterService = new RequestService<_.Lagringsformat, 'Lagringsformater'>('Lagringsformater');
export const presedensTagTypeService = new PresedensTagTypeService('presedensTagType');
export const menyListeService = new RequestService<_.MenyListe, 'MenyListe'>('MenyListe');

export const datatypeService = new RequestService<_.Datatype, 'Datatype'>('Datatype');
export const formatTypeService = new RequestService<_.FormatType, 'FormatType'>('FormatType');
export const flytstatusService = new FlytstatusService('flytstatus');
export const miljoService = new MiljoService();
export const miljoVariabelService = new SubEntityRequestService<MiljoVariabel>('miljo', 'variabel');
export const systemparameterService = new SystemparameterService('systemparameter');
export const nodeMenyService = new RequestTreeService<_.NodeMeny, 'nodeMeny'>('nodeMeny');
export const nodeTilgangService = new NodeTilgangService();

export const arsskifteServices = new ArsskifteServices();
export const meServices = new MeServices();

export const defaultProviderService = new RequestService<_.DefaultProvider, 'DefaultProvider'>('DefaultProvider');
export const indekseringLoggService = new RequestService<_.IndekseringLogg, 'IndekseringLogg'>('IndekseringLogg');
export const startIndekseringService = new IndekseringLoggService('indekseringLogg');
//#endregion System
export const foretakstypeService = new RequestService<_.Foretakstype, 'foretakstype'>('foretakstype');

export const bortsettingsKodeService = new RequestService<_.BortsettingsKode, 'bortsettingsKode'>('bortsettingsKode');
export const referansekodeService = new ReferansekodeService('referansekode');

export const tilleggsdataService = new TilleggsdataService('tilleggsdata');
export const tilleggsDataVerdiService = new SubEntityRequestService<DataVerdi>('tilleggsdata', 'verdi');

export const tilleggsdataKoblingService = new TilleggsdataKoblingService();

//#region Eiendom
export const ansvarstypeService = new RequestService<_.Ansvarstype, 'ansvarstype'>('ansvarstype');
export const dispensasjonService = new RequestService<_.Dispensasjon, 'dispensasjon'>('dispensasjon');
export const fagomraadeService = new RequestService<_.Fagomraade, 'fagomraade'>('fagomraade');

export const gebyrtypeService = new RequestService<_.Gebyrtype, 'gebyrtype'>('gebyrtype');
export const saksbehandlingstypeService = new RequestService<_.Saksbehandlingstype, 'saksbehandlingstype'>('saksbehandlingstype');


export const saksbehandlingStatusService = new RequestService<_.SaksbehandlingStatus, 'saksbehandlingStatus'>('saksbehandlingStatus');
export const teksttabellService = new RequestService<_.Teksttabell, 'teksttabell'>('teksttabell');
export const varslingService = new RequestService<_.Varsling, 'varsling'>('varsling');
export const varslingEpostTestService = new VarslingService('varsling');
//#endregion Eiendom




